import { PREMIUM_FEATURES } from "@common/flatRateBilling";
import { useAllowFeature } from "@hooks/useAllowFeature";
import { ArAgingReportsPaywalled } from "./ArAgingReportsPaywalled";
import { ArAgingSummaryPage } from "./ArAgingSummaryPage";

export const ArAgingSummaryPageWrapper = () => {
    const { hasAccess, isFetched } = useAllowFeature(
        PREMIUM_FEATURES.ACCRUAL_LEDGER,
    );

    if (!isFetched) {
        return null;
    }

    if (!hasAccess) {
        return <ArAgingReportsPaywalled />;
    }

    return <ArAgingSummaryPage />;
};
